import { render, staticRenderFns } from "./RetailerTermsAndConditions.vue?vue&type=template&id=225e9ec2&scoped=true&"
import script from "./RetailerTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./RetailerTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./RetailerTermsAndConditions.vue?vue&type=style&index=0&id=225e9ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e9ec2",
  null
  
)

export default component.exports